export default {
  isPageLoad (state) {
    state.pageLoad = true
    state.templateLoad = true
  },
  pageLoad (state) {
    state.pageLoad = false
    state.templateLoad = false
  },
  isTemplateLoad (state) {
    state.templateLoad = true
  },
  domain (state, data) {
    state.domain = data 
  },
  templateLoad (state) {
    state.templateLoad = false
  },
  currentPage (state, data) {
    state.currentPage = data
  },
  currentTemplate (state, data) {
    state.currentTemplate = data
  },
  setEditor (state, data) {
    state.editor = data 
  },
  Auth (state, data) {
    state.user = data 
  },
  cityList (state, data) {
    state.cityList = data.list
    state.host = data.host
  },
  setApi (state, data) {
    state.api = data
  }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js